import Acordeon from "../acordeon";
var listaDesplegable = function () {
    var listas = [].slice.call(document.querySelectorAll('.lista_desplegable dl'));
    listas.forEach(function (lista) {
        var terminos = [].slice.call(lista.querySelectorAll('dt'));
        terminos.forEach(function (termino, i) {
            var dd = termino.nextElementSibling;
            dd.id = "".concat(lista.id, "-").concat(i + 1);
            termino.innerHTML = "<button aria-controls=\"".concat(dd.id, "\">").concat(termino.innerHTML, "</button>");
        });
        new Acordeon(lista);
    });
};
export default listaDesplegable;
